
export default function HeroSection() {
  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <video
          className="w-full h-full object-cover"
          autoPlay
          loop
          muted
          playsInline
        >
          <source src="https://www.whizcompany.com/images/main/main.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 text-center px-6 w-full">
        <div className="max-w-4xl mx-auto" data-aos="fade-up">
          <img
            src="https://static.readdy.ai/image/0adaafd12e96644bb3f30378f0b23f95/ff543a3bc213124683bd6341c497bd82.png"
            alt="Whiz Company"
            className="mx-auto mb-8 h-24 w-auto object-contain"
          />
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 font-display">
            <span className="md:hidden">다같이<br />잘벌고 잘먹고 잘살자</span>
            <span className="hidden md:inline">다같이 잘벌고 잘먹고 잘살자</span>
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-12 font-light">
            " 한성은 식구食口 입니다. "
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) {
                const offset = 80;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - offset;
                window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
              }
            }}
            className="bg-primary hover:bg-accent text-white px-10 py-4 rounded-full text-base font-medium transition-all duration-300 hover:scale-105 shadow-lg cursor-pointer whitespace-nowrap"
          >
            문의하기
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
